import { motion, useReducedMotion } from "framer-motion";

export default function Reveal({
  children,
  className = "",
  delay = 0,
  y = 28,
  once = true,
  amount = 0.2,
  as: Tag = "div",
}) {
  const reduce = useReducedMotion();
  const MotionTag = motion[Tag] || motion.div;

  return (
    <MotionTag
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={reduce ? undefined : { opacity: 1, y: 0 }}
      viewport={{ once, amount }}
      transition={{
        duration: 0.8,
        delay,
        ease: [0.25, 1, 0.3, 1],
      }}
    >
      {children}
    </MotionTag>
  );
}
